import React, { useEffect } from 'react';

import { DatePicker, Divider, Form, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface NewGeoVictoriaToBukDateConfigurationModalProps {
  isNewConfigurationModalOpen: boolean;
  handleNewConfigurationModalOk: (
    executedAt: string,
    startDate: string,
    endDate: string
  ) => void;
  handleNewConfigurationModalCancel: () => void;
  loading: boolean;
}

const { RangePicker } = DatePicker;

function NewGeoVictoriaToBukDateConfigurationModal({
  isNewConfigurationModalOpen,
  handleNewConfigurationModalOk,
  handleNewConfigurationModalCancel,
  loading,
}: NewGeoVictoriaToBukDateConfigurationModalProps) {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dateFormat: string = useSelector(
    (s: any) => s.intl?.dateFormat || 'DD/MM/YYYY'
  );

  useEffect(() => {
    if (isNewConfigurationModalOpen) {
      form.setFieldValue('executedDate', null);
      form.setFieldValue('range', null);
    }
  }, [isNewConfigurationModalOpen]);

  const onFinish = (values: any) => {
    console.log('Onfinish', values);
    if (values.executedDate && values.range) {
      handleNewConfigurationModalOk(
        values.executedDate.format('YYYY-MM-DD'),
        values.range[0].format('YYYY-MM-DD'),
        values.range[1].format('YYYY-MM-DD')
      );
    }
  };

  const validateRange = (rule: any, value: any) => {
    const executedDate = form.getFieldValue('executedDate');
    if (!value || !executedDate) {
      return Promise.resolve();
    }
    if (value[1].isAfter(executedDate, 'day')) {
      return Promise.reject(
        t(
          'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.validations.range_end_after_exec'
        )
      );
    }
    return Promise.resolve();
  };

  return (
    <Modal
      title={t(
        'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.title'
      )}
      open={isNewConfigurationModalOpen}
      onOk={() => {
        form.submit();
      }}
      onCancel={handleNewConfigurationModalCancel}
      okText={t(
        'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.ok_text'
      )}
      maskClosable={false}
      confirmLoading={loading}
    >
      <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="executedDate"
          label={t(
            'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.labels.executed_date'
          )}
          rules={[
            {
              required: true,
              message: t(
                'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.validations.required'
              ),
            },
          ]}
        >
          <DatePicker
            placeholder={t(
              'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.placeholders.select_date'
            )}
            style={{ width: '100%' }}
            format={dateFormat}
          />
        </Form.Item>
        <Form.Item
          name="range"
          label={t(
            'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.labels.range'
          )}
          rules={[
            {
              required: true,
              message: t(
                'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.validations.required'
              ),
            },
            { validator: validateRange },
          ]}
        >
          <RangePicker
            style={{ width: '100%' }}
            format={dateFormat}
            placeholder={[
              t(
                'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.placeholders.start_date'
              ),
              t(
                'scenes.geovictoria.geo_victoria_to_buk_date_configuration.components.new_configuration_modal.placeholders.end_date'
              ),
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default NewGeoVictoriaToBukDateConfigurationModal;
